import { render, staticRenderFns } from "./outside.vue?vue&type=template&id=f2698cb8&scoped=true&lang=pug&"
import script from "./outside.vue?vue&type=script&lang=js&"
export * from "./outside.vue?vue&type=script&lang=js&"
import style0 from "./outside.vue?vue&type=style&index=0&id=f2698cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2698cb8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CookiesSnackbar: require('/home/node/components/shared/CookiesSnackbar.vue').default})
